<template>
  <div class="p_doc_box">
    <div class="topOperation">
        <div class="top-left">
            <div><ShowNavHead/></div>
        </div>
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>知识库</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/document' }">使用指南</el-breadcrumb-item>
                <el-breadcrumb-item>{{pageTitle}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="p_doc_content">
            <!-- <el-tabs :tab-position="tabPosition">
                <el-tab-pane label="使用指南"></el-tab-pane>
            </el-tabs> -->
            <p class="doc_txt">{{pageTitle}}</p>
            <div class="class-video">
                <video id="video02" ref="myVideo" controls oncontextmenu="return false"  x5-video-player-type="h5-page" style="width:100%;max-height:500px;object-fit: scale-down;" webkit-playsinline="true" playsinline="true" poster="" controlslist="nodownload">
                    <source :src="videoSrc"
                    type="video/mp4">
                    Your browser does not support the video tag. 
                </video>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listQuery:{
          currpage:1,
          perpage:10
      },
      pageTitle:'系统使用视频',
      videoSrc:'https://jbimg-1307451135.cos.ap-shanghai.myqcloud.com/helpfile/helpfile.mp4',
      tabPosition: 'top',
      tableData:[
        {
            indexNum:'1',
            auther:'', //作者
            department:'',//部门
            datetime:'2022-10-12',//发布时间
            classify:'客服使用视频',//所属分类
            title:'系统使用视频'
        },
        {
            indexNum:'2',
            auther:'',
            department:'',
            datetime:'2022-10-12',
            classify:'客服使用手册',
            title:'使用手册'
        }
      ],
      videoVisible:false,
      activeNames: ['1'],
      multipleSelection: [],
      total:0,
      // 视频类型
      videoType:''
    }
  },
  created() {
      this.total = this.tableData.length
      this.videoType = this.$route.query.type
      if(this.videoType == '1'){//系统使用视频
        this.pageTitle = '系统使用视频'
        this.videoSrc = 'https://jbimg-1307451135.cos.ap-shanghai.myqcloud.com/helpfile/helpfile.mp4'
      }
      if(this.videoType == '3'){//报增
        this.pageTitle = '保险-商保(报增)流程'
        this.videoSrc = 'https://jbvideo-1307451135.cos.ap-shanghai.myqcloud.com/helpfile/%E4%BF%9D%E9%99%A9-%E5%95%86%E4%BF%9D%EF%BC%88%E6%8A%A5%E5%A2%9E%EF%BC%89%E6%B5%81%E7%A8%8B2024-01-31.mp4'
      }
      if(this.videoType == '4'){//报减
        this.pageTitle = '保险-商保(报减)流程'
        this.videoSrc = 'https://jbvideo-1307451135.cos.ap-shanghai.myqcloud.com/helpfile/%E4%BF%9D%E9%99%A9-%E5%95%86%E4%BF%9D%EF%BC%88%E6%8A%A5%E5%87%8F%EF%BC%89%E6%B5%81%E7%A8%8B2024-01-31.mp4'
      }
      if(this.videoType == '5'){//在保
        this.pageTitle = '保险-商保(在保)查询'
        this.videoSrc = 'https://jbvideo-1307451135.cos.ap-shanghai.myqcloud.com/helpfile/%E4%BF%9D%E9%99%A9-%E5%95%86%E4%BF%9D%EF%BC%88%E5%9C%A8%E4%BF%9D%EF%BC%89%E6%9F%A5%E8%AF%A22024-01-31.mp4'
      }if(this.videoType == '6'){
        this.pageTitle = '(1-1花名册存量员工处理-步骤一)客户-存档花名册-导入'
        this.videoSrc = 'https://jbvideo-1307451135.cos.ap-shanghai.myqcloud.com/helpfile/18737_1717055011.mp4'
      }if(this.videoType == '7'){
        this.pageTitle = '(1-2花名册存量员工处理-步骤二)雇员-面试入职流程-花名册列表-在离职核对'
        this.videoSrc = 'https://jbvideo-1307451135.cos.ap-shanghai.myqcloud.com/helpfile/18740_1717055379.mp4'
      }if(this.videoType == '8'){
        this.pageTitle = '雇员-面试入职流程'
        this.videoSrc = 'https://jbvideo-1307451135.cos.ap-shanghai.myqcloud.com/helpfile/18742_1717055565.mp4'
      }if(this.videoType == '9'){
        this.pageTitle = '薪酬-算薪发薪流程'
        this.videoSrc = 'https://jbvideo-1307451135.cos.ap-shanghai.myqcloud.com/helpfile/18799_1717145558.mp4'
      }if(this.videoType == '10'){
        this.pageTitle = '薪酬-算薪核对流程'
        this.videoSrc = 'https://jbvideo-1307451135.cos.ap-shanghai.myqcloud.com/helpfile/18801_1717145754.mp4'
      }
  },
  methods: {
      //分页
    changeBPage(val){
        this.listQuery.currpage = Number(val)
        // this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.currpage = 1
      this.listQuery.perpage = Number(val)
    //   this.getList()
    },
    handleSelectionChange(val){
        this.multipleSelection = val
    },
    videoHandle(){
        this.videoVisible = true
        this.$nextTick(() => {
            this.$refs.myVideo.pause()
        })
        // if (!(this.$refs.myVideo.paused)){
            // this.handlePause()
        // }
    },
    closeHandle(){
        this.videoVisible = false
        this.$refs.myVideo.pause()
    },
    handleChange(val) {
        console.log(val)
      },
      dtlVideoJump(){
        this.$router.push({
          path: '/dtlVideo'
        })
      },
      dtlDocJump(){
        this.$router.push({
          path: '/dtlDoc'
        })
      }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
<style scoped>
.p_doc_content{
    min-height: 800px;
    padding: 20px;
    background-color: #fff;
}
.p_doc_content .doc_txt{
    padding: 0 0 10px;
    text-align: center;
    font-size: 16px;
    color:#333;
    border-bottom: 1px dashed #ddd;
}
.el-pagination{
  background-color: #fff;
}
</style>